import styled from 'styled-components';

const MarketingSectionWrapper = styled.div`
  margin-top: 30px;
`;

MarketingSectionWrapper.displayName = 'MarketingSectionWrapper';

export default MarketingSectionWrapper;
